import { useEffect, useState } from 'react';

interface EditableCellProps {
  value: unknown;
  disabled?: boolean;
  onCommit: (value: string) => void;
}

export function EditableCell({ value, disabled = false, onCommit }: EditableCellProps) {
  const [inputValue, setInputValue] = useState(value == null ? '' : String(value));

  useEffect(() => {
    setInputValue(value == null ? '' : String(value));
  }, [value]);

  return (
    <input
      value={inputValue}
      disabled={disabled}
      onChange={event => setInputValue(event.target.value)}
      onBlur={() => onCommit(inputValue)}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          event.currentTarget.blur();
        }
      }}
      className='h-full w-full min-w-0 border-0 bg-transparent px-0 py-0 text-[12.5px] outline-none disabled:cursor-default disabled:text-inherit'
    />
  );
}
